<script>
import { required } from "vuelidate/lib/validators";
import {cloneDeep} from 'lodash';
export default {
    name: "BacMemberModal",
    data() {
        return {
            member: {
                id: 0,
                bacSettingId: 0,
                applicationUserId: null,
                position: null,
                employeeName: null,
                isActive: true,
                receiveEmail: false,
                receiveSMS: false
            },
            submitted: false,
        }
    },
    validations: {
        member: {
            applicationUserId: {required},
            position: {required},
        },
    },
    methods: {
        selectEmployee(){
            this.$emit('openEmployee')
        },
        dropEmployee(e){
            this.member.applicationUserId =  e.applicationUser.id;
            this.member.employeeName = e.applicationUser.completeName;
        },
        onCreateMember() {
            this.submitted = true;
            this.$v.member.$touch();
            if (this.$v.member.$invalid) {
                return;
            } 
            var data = cloneDeep(this.member);
            this.$emit('onSubmit', data);
            this.submitted = false;
        },
    }
}
</script>
<template>
    <b-modal
        id="add-member-modal"
        title="Add Member"
        size="md"
        title-class="font-18"
        hide-footer
        no-close-on-backdrop
        no-close-on-esc
    >
        <form
            @submit.prevent="onCreateMember"
            class="needs-validation"
            ref="memForm"
        >
            <div class="mb-3">
                <label for="name">Employee </label>
                <b-input-group>
                    <template
                        #append
                    >
                        <b-button
                            @click="selectEmployee"
                            variant="outline-info"
                            ><i
                                class="
                                    mdi
                                    mdi-clipboard-text-search-outline
                                "
                            ></i
                        ></b-button>
                    </template>
                    <input
                        id="name"
                        type="text"
                        v-model="member.employeeName"
                        placeholder="Select Member Name..."
                        class="form-control"
                        :class="{
                            'is-invalid': submitted && $v.member.applicationUserId.$error,
                        }"
                        disabled
                    />
                </b-input-group>
                <div
                    v-if="submitted && $v.member.applicationUserId.$error"
                    class="invalid-feedback"
                >
                    <span v-if="!$v.member.applicationUserId.required"
                        >This value is required.</span
                    >
                </div>
            </div>
            <div class="mb-3">
                <label for="name">Position </label>
                <select name="position" class="form-select" v-model="member.position" 
                    :class="{
                        'is-invalid': submitted && $v.member.position.$error,
                    }"
                >
                    <option></option>
                    <option>CHAIRPERSON</option>
                    <option>VICE CHAIRPERSON</option>
                    <option>REGULAR MEMBER</option>
                    <option>CAMPUS HEAD</option>
                    <option>PROVISIONAL MEMBERS</option>
                    <option>TECHNICAL REVIEWER</option>
                </select>
                <div
                    v-if="submitted && $v.member.position.$error"
                    class="invalid-feedback"
                >
                    <span v-if="!$v.member.position.required"
                        >This value is required.</span
                    >
                </div>
            </div>
            <div class="d-flex mb-3">
                <div class="form-check form-checkbox-outline form-check-success mb-0">
                    <input
                        type="checkbox"
                        :id="`Email`"
                        class="form-check-input"
                        v-model="member.receiveEmail"
                    />
                    <label
                        :for="`Email`"
                        class="form-check-label no-wrap"
                    >
                        Receive Email
                    </label>
                </div>
                <div class="form-check form-checkbox-outline form-check-success mb-0 ms-2">
                    <input
                        type="checkbox"
                        :id="`SMS`"
                        class="form-check-input"
                        v-model="member.receiveSMS"
                    />
                    <label
                        :for="`SMS`"
                        class="form-check-label no-wrap"
                    >
                        Receive SMS
                    </label>
                </div>
            </div>
            <div class="modal-footer">
                <button type="submit" class="btn btn-primary">
                    Save changes
                </button>
                <button
                    type="button"
                    class="btn btn-link"
                    @click="$bvModal.hide('add-member-modal')"
                >
                    Close
                </button>
            </div>
        </form>
    </b-modal>
</template>